import {DetailsList, PrimaryButton, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useOutletContext, useParams} from 'react-router-dom';
import AuthContext from "../../Services/AuthContext";
import AddVentureDocument from "../../Panel/VentureDocument/AddVentureDocument";

function VentureDocument() {
    const [user] = useContext(AuthContext);
    const {actions} = useOutletContext();
    const [documents, setDocuments] = useState([]);
    const [groups, setGroups] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/${params.id}/document`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    if (data[0].id !== null) {
                        setDocuments(data);
                        _generateGroups(data);
                    } else {
                        setDocuments([]);
                        setGroups([]);
                    }
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);
    useEffect(() => {
        actions([
            {
                key: 'addDocument',
                text: 'Dodaj',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddDocument({venture_id: params.id})
            }
        ]);
        return actions;
    }, []);

    const [addDocument, setAddDocument] = useState(false);

    const columns = [
        {
            key: 'name',
            name: 'Nazwa Dokumentu',
            ariaLabel: 'Nazwa Dokumentu',
            fieldName: 'name',
            minWidth: 300,
            isRowHeader: true,
            isResizable: false,
            onRender: (item) => (<a href={`/api/public/uploaded/${item.filename}`} target={'_blank'}><PrimaryButton text={item.name} /></a>)
        },
        {
            key: 'group',
            name: 'Grupa',
            ariaLabel: 'Grupa',
            fieldName: 'group',
            minWidth: 200,
            isResizable: true,
            onRender: (item) => item.group === 'null' ? '' : item.group
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: true,
        },
        {
            key: 'user',
            name: 'Użytkownik',
            ariaLabel: 'Użytkownik',
            fieldName: 'user',
            minWidth: 120,
            isResizable: true
        }
    ];

    const _generateGroups = (data) => {
        let array = [];
        let last = '';
        let index = 0;
        data.forEach((item) => {
            if (last !== item.group) {
                if (item.group === 'null') {
                    array.push({key: item.group, name: 'Inne', count: 0, startIndex: index, level: 0});
                } else {
                    array.push({key: item.group, name: item.group, count: 0, startIndex: index, level: 0, isCollapsed: true});
                }
            }
            array[array.length - 1].count++;
            last = item.group;
            index++;
        });
        setGroups(array);
    }
    return (
        <>
            <DetailsList items={documents} columns={columns} groups={groups} selectionMode={SelectionMode.none} />
            <AddVentureDocument add={addDocument} dismissPanel={() => setAddDocument(false)} onSuccess={() => setRefresh(refresh + 1)}/>
        </>
    );
}

export default VentureDocument;